import React from 'react';

const Choice = props => {
  const {letter, selectAnswer} = props;

  return <button key={letter} className='btn btn__choice' onClick={() => selectAnswer(letter)}>{letter}</button>;
};

export default Choice;
